var M = Object.defineProperty;
var W = (r, t, e) => t in r ? M(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var o = (r, t, e) => (W(r, typeof t != "symbol" ? t + "" : t, e), e);
const y = {
  BEFORE_MERGE: "BEFORE_MERGE",
  AFTER_MERGE: "AFTER_MERGE"
}, w = {
  clean: {
    enabled: !1,
    executionPlace: y.AFTER_MERGE,
    values: ["", void 0, null]
  },
  logging: {
    enabled: !0,
    level: "warn"
  },
  validation: {
    enabled: !1,
    allowUnknown: !1,
    verbose: !0
  },
  webProperties: {
    enabled: !0,
    eventNamePattern: /.*/,
    reactiveUrl: !0,
    reactiveDimensions: !0
  }
};
class U {
  /**
   * Creates a PCOM (default) data layer schema specific object, that contains the given event name.
   *
   * @param data - Contains the event name in a standardized {@link IFactoryData} like way.
   *
   * @returns The event name in the PCOM (default) data layer schema specific object.
   *
   * @example
   * myEventNameFactory.create({ event: 'MY_EVENT_NAME' });
   * // returns:
   * // {
   * //   context: {
   * //     eventAction: 'MY_EVENT_NAME'
   * //   }
   * // }
   */
  create(t) {
    return typeof t.event != "string" || t.event.length === 0 ? {} : {
      context: {
        eventAction: t.event
      }
    };
  }
}
const N = (r, t) => {
  let e;
  for (e in r)
    if (!(!r || !r[e]) && t(r[e], e) === !1)
      return !1;
  return !0;
}, _ = (r, t) => N(r, (e, s) => {
  for (const i in r[s])
    if (t(e[i], i, e, s) === !1)
      return !1;
  return !0;
}), ne = (r) => {
  if (m(r))
    return !0;
  let t = 0, e = 0;
  return N(r, (s) => {
    t++, m(s) && e++;
  }), t === e;
}, m = (r) => {
  for (const t in r)
    return !1;
  return !0;
}, P = (r, t = ((e) => (e = w.clean) == null ? void 0 : e.values)() || []) => (_(
  r,
  (s, i, n, l) => {
    t.includes(s) && (delete n[i], m(n) && delete r[l]);
  }
), r), G = (r, t) => r && (_(
  r,
  (e, s, i, n) => {
    t.includes(`${n.toString()}.${s.toString()}`) && (delete i[s], m(i) && delete r[n]);
  }
), r), V = (r) => (N(r, (t, e) => (typeof t != "function" || (r[e] = t()), !0)), _(
  r,
  (t, e, s) => (typeof t != "function" || (s[e] = t()), !0)
), r);
class H {
  /**
   * Creates a new instance of {@link FrameTicker}.
   *
   * @param callback The functionality that should be called
   * @param ticksPerSecond How many times should the functionality been called in one second
   */
  constructor(t, e = 10) {
    o(this, "tickInterval");
    o(this, "callback");
    o(this, "_tickTime", Date.now());
    o(this, "_tickActive", !1);
    this.callback = t, this.tickInterval = 1e3 / e;
  }
  /**
   * Start the {@link FrameTicker}.
   */
  start() {
    this._tickActive || (this._tickActive = !0, this.run());
  }
  /**
   * Stop the {@link FrameTicker}.
   */
  stop() {
    this._tickActive = !1;
  }
  /**
   * Internal function executed on each _tick_.
   *
   * @private
   */
  run() {
    if (!this._tickActive)
      return;
    requestAnimationFrame(this.run.bind(this));
    const t = Date.now(), e = t - this._tickTime;
    e < this.tickInterval || (this._tickTime = t - e % this.tickInterval, this.callback());
  }
}
const B = (r, t) => {
  const e = t.split(".");
  if (e.length !== 2)
    return;
  const s = r[e[0]];
  if (s)
    return s[e[1]];
}, C = (r) => {
  if (!r)
    return [];
  const t = [];
  return _(
    r,
    (e, s, i, n) => {
      t.push(`${n.toString()}.${s.toString()}`);
    }
  ), t;
}, j = w.logging;
var x = /* @__PURE__ */ ((r) => (r[r.error = 0] = "error", r[r.warn = 1] = "warn", r[r.log = 2] = "log", r))(x || {});
const v = class v {
  /**
   * Creates an instance of the {@link Logger} class.
   *
   * @param prefix A prefix that is used in all logs
   *   (`[PREFIX] MESSAGE`, i.e. `[GlobalDataLayer] This is a serious message`).
   * @param options Options to be merged as settings with the {@link DEFAULT_SETTINGS.logging}.
   */
  constructor(t, e) {
    /**
     * The prefix that is used in all logs.
     * @private
     */
    o(this, "prefix");
    /**
     * The merged settings. Also see the options of the {@link constructor} and the {@link DEFAULT_SETTINGS.logging}.
     *
     * @see {@link TLoggerSettings}
     *
     * @private
     */
    o(this, "settings");
    this.prefix = t, this.settings = {
      ...j,
      ...e
    };
  }
  /**
   * Helper function to merge the options of a log method call with the current {@link settings}.
   *
   * @param options  Options to be merged with the available {@link settings}
   *
   * @returns The merged temporary settings.
   *
   * @private
   */
  _getMergedSettings(t) {
    return t ? {
      ...this.settings,
      ...t
    } : this.settings;
  }
  /**
   * Check, if this log message is allowed.
   *
   * @see {@link TLoggerSettings.enabled} and {@link TLoggerSettings.level} and {@link isAvailable}
   *
   * @param type Type of the current log message.
   * @param settings The current (temporary) settings.
   *
   * @returns `true`if the log message is allowed.
   *
   * @private
   */
  _isAllowed(t, e) {
    if (!v.isAvailable || !e.enabled)
      return !1;
    const s = x[e.level];
    switch (t) {
      case "error":
      case "warn":
        return s >= x[t];
      case "info":
      case "log":
      case "debug":
      case "dir":
        return s >= 2;
      default:
        return !1;
    }
  }
  /**
   * A helper method to execute the log messages of all different types.
   *
   * @param msg The message text.
   * @param type The type of the message.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   *
   * @private
   */
  _log(t, e = "log", s) {
    const i = this._getMergedSettings(s);
    if (this._isAllowed(e, i))
      switch (e) {
        case "dir":
          console.log(`[${this.prefix}] ${e}:`), console[e](t);
          break;
        default:
          console[e](`[${this.prefix}] ${t}`);
      }
  }
  /**
   * Write a normal log message.
   *
   * @param msg The message text.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   */
  log(t, e) {
    this._log(t, "log", e);
  }
  /**
   * Write a log message of type `dir`.
   *
   * This message will be split in two messages, the prefix with " dir:" and the
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/console/dir dir} output as interactive list.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/console/dir console.dir()}
   *
   * @param msg The message text.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   */
  dir(t, e) {
    this._log(t, "dir", e);
  }
  /**
   * Write a log message of type `debug`.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/console/debug console.debug()}
   *
   * @param msg The message text.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   */
  debug(t, e) {
    this._log(t, "debug", e);
  }
  /**
   * Write a log message of type `error`.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/console/error console.error()}
   *
   * @param msg The message text.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   */
  error(t, e) {
    this._log(t, "error", e);
  }
  /**
   * Write a log message of type `info`.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/console/info console.info()}
   *
   * @param msg The message text.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   */
  info(t, e) {
    this._log(t, "info", e);
  }
  /**
   * Write a log message of type `warn`.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/console/warn console.warn()}
   *
   * @param msg The message text.
   * @param options Temporary options, that will be merged with the current {@link settings}.
   */
  warn(t, e) {
    this._log(t, "warn", e);
  }
};
/**
 * Check if there is a console available that makes logging possible.
 */
o(v, "isAvailable", (() => typeof console < "u")());
let b = v;
const u = (...r) => {
  const t = {};
  return r.forEach((e) => {
    if (m(e))
      return;
    const s = {
      ...t,
      ...e
    };
    let i;
    for (i in s)
      typeof s[i] == "object" && !Array.isArray(s[i]) ? t[i] = {
        ...t[i],
        ...e[i]
      } : t[i] = s[i];
  }), t;
};
class q {
  /**
   * Creates a PCOM (default) data layer schema specific object, that contains the given web properties.
   *
   * @param data - Contains the web properties in a standardized {@link IFactoryData} like way.
   *
   * @returns The given web properties in the PCOM (default) data layer schema specific object.
   *
   * @example
   * myWebPropertiesFactory.create({ userAgent: 'MY_USE_AGENT' });
   * // returns:
   * // {
   * //   visitor: {
   * //     userAgent: 'MY_USE_AGENT'
   * //   }
   * // }
   */
  create(t) {
    return P(
      {
        context: {
          timestamp: t.timestamp,
          server: t.hostname
        },
        pageExperience: {
          pageId: t.url
        },
        visitor: {
          deviceBrowserBreakpoint: t.breakpoint,
          deviceBrowserHeight: t.height,
          deviceBrowserOrientation: t.orientation,
          deviceBrowserWidth: t.width,
          deviceType: t.deviceType,
          useragent: t.userAgent
        }
      },
      [void 0]
    );
  }
}
const K = w.webProperties, R = () => window.location.href.replace(/[?#].*/, ""), Y = () => (/* @__PURE__ */ new Date()).toISOString(), Q = () => window.location.hostname, D = () => window.innerHeight.toString(), T = () => window.innerHeight > window.innerWidth ? "p" : "l", A = () => window.innerWidth.toString(), X = () => window.matchMedia("(hover: none), (pointer: coarse)").matches ? "mobile" : "desktop", z = () => window.navigator.userAgent, J = (r) => {
  if (!r.breakpoints || r.breakpoints.length < 1)
    return;
  const { breakpoints: t } = r, e = () => {
    const s = window.innerWidth;
    let i = 0, n = 0;
    for (; n < t.length && s >= t[n]; )
      i = t[n], n++;
    return i.toString();
  };
  return r.reactiveDimensions ? e : e();
}, Z = (r, t) => {
  const e = {
    ...K,
    ...r
  }, i = {
    breakpoint: J(e),
    timestamp: Y(),
    hostname: Q(),
    url: e.reactiveUrl ? R : R(),
    height: e.reactiveDimensions ? D : D(),
    orientation: e.reactiveDimensions ? T : T(),
    width: e.reactiveDimensions ? A : A(),
    deviceType: X(),
    userAgent: z()
  };
  return t ? t.create(i) : i;
}, ee = (r, t) => {
  switch (t) {
    case "string":
    case "number":
    case "boolean":
      return typeof r === t;
    case "any[]":
      return Array.isArray(r) && r.length > 0;
    case "Record<string, any>":
      return typeof r == "object" && !Array.isArray(r) && Object.keys(r).length > 0;
    case "any":
      return !0;
    default:
      if ((typeof r == "boolean" || typeof r == "number" || typeof r == "string") && t.indexOf("|") > 0)
        return t.split("|").map((s) => {
          const i = s.trim();
          return /^'.*'$/.test(i) ? i.replace(/(^ ?'?|'? ?$)/g, "") : /^(true|false)$/.test(i) ? i === "true" : /^-?(\d*\.)?\d+$/.test(i) ? Number.parseFloat(i) : i.replace(/(^ ?'?|'? ?$)/g, "");
        }).includes(r);
  }
  return !0;
}, te = (r, t, e) => {
  const s = {
    level: null,
    issues: []
  };
  if (!e.enabled || !e.eventMatrix)
    return s;
  const { events: i, ...n } = e.eventMatrix, l = i.indexOf(r);
  if (l === -1)
    return s.level = "error", s.issues.push({
      level: "error",
      type: "EVENT_NOT_FOUND",
      name: r,
      message: `'${r}': Event does not exist.`
    }), s;
  const a = C(t), d = Object.keys(n), c = a.filter(
    (g) => !d.includes(g)
  );
  c.length > 0 && (e.allowUnknown || G(t, c), c.forEach((g) => {
    s.level = s.level ?? "warn", s.issues.push({
      level: "warn",
      type: "PROPERTY_DOES_NOT_EXIST",
      name: g,
      message: `'${g}': Property does not exist in the given Event Matrix.${e.allowUnknown ? "" : " It was omitted from the DataLayer payload."}`
    });
  }));
  let h;
  for (h in n) {
    const g = n[h], f = typeof g.e[l] < "u", p = g.r === 1, E = t ? B(t, h) : void 0, k = typeof E < "u";
    if (f && // Does the event want this property?
    p && // Is the property mandatory in general?
    !k && (s.level = "error", s.issues.push({
      level: "error",
      type: "REQUIRED_PROPERTY_MISSING",
      name: h,
      message: `'${h}': The required property is missing.`
    }), !e.verbose) || k && !ee(E, g.t) && (s.level = "error", s.issues.push({
      level: "error",
      type: "WRONG_PROPERTY_TYPE",
      name: h,
      message: `'${h}': Wrong type detected. Expected '${g.t}', got '${typeof E}'.`
    }), !e.verbose))
      return s;
  }
  return s;
};
class L {
  constructor(t = "DataLayerExtension", e) {
    /**
     * A
     * @protected
     */
    o(this, "_logger");
    o(this, "_className");
    o(this, "_dataLayerInstance");
    this._className = t, this._logger = new b(this.className, e);
  }
  get dataLayerInstance() {
    return this._dataLayerInstance;
  }
  set dataLayerInstance(t) {
    this._dataLayerInstance = t;
  }
  get className() {
    return this._className;
  }
  set className(t) {
    this._className = t;
  }
  get isRegistered() {
    return typeof this._dataLayerInstance < "u";
  }
}
const F = {
  eventName: "UNKNOWN",
  thresholds: {
    filled: 0.5,
    visible: 0.3,
    minValidityPeriod: 1
  },
  triggerUpdates: {
    enabled: !1,
    eventName: "VIEWPORT_TRACKER_STATUS_CHANGE"
  },
  tickerSettings: {
    ticksPerSecond: 10
  }
};
class se extends Event {
  constructor(e, s) {
    super(e);
    o(this, "registeredElement");
    this.registeredElement = s;
  }
}
class $ extends L {
  /**
   * Creates a new instance of {@link ViewportTrackerExtension} with optional settings of type
   * {@link TViewportTrackerSettings}.
   *
   * @param options The settings to initialize the instance. Will be merged with the defaults.
   */
  constructor(e) {
    var s;
    super("ViewportTrackerExtension", e == null ? void 0 : e.logger);
    o(this, "settings");
    o(this, "observer", null);
    o(this, "frameTicker");
    o(this, "registeredElements", []);
    o(this, "visibleElements", []);
    this.settings = e ? u(F, e) : F, this.observer = this.createObserver(), this.frameTicker = new H(
      this.checkVisibilityOfElements.bind(this),
      (s = this.settings.tickerSettings) == null ? void 0 : s.ticksPerSecond
    );
  }
  /**
   * Will create and return the mandatory {@link IntersectionObserver}. The function will log an error if this is not
   * possible.
   *
   * @returns The ready-to-use {@link IntersectionObserver} instance or null.
   *
   * @private
   */
  createObserver() {
    return !window || !("IntersectionObserver" in window) ? (this._logger.error("The ViewportTrackerExtension will need IntersectionObserver to work."), null) : new IntersectionObserver(this.observerHandler.bind(this), {
      threshold: 0,
      rootMargin: "0px 0px"
    });
  }
  /**
   * Register an {@link HTMLElement} to be observed.
   *
   * @param element The {@link HTMLElement} to register with optional _DataLayer_ properties.
   */
  registerElement(e) {
    var s;
    this.unregisterElement(e.el), this.registeredElements.push({
      el: e.el,
      properties: e.properties,
      state: {
        isFilled: !1,
        isVisible: !1,
        passedValidityPeriod: !1
      }
    }), (s = this.observer) == null || s.observe(e.el);
  }
  /**
   * Register multiple {@link HTMLElement}s to be observed.
   *
   * @param elements The {@link HTMLElement}s to register with optional _DataLayer_ properties.
   */
  registerElements(e) {
    for (const s of e)
      this.registerElement(s);
  }
  /**
   * Unregister an {@link HTMLElement} from observation.
   *
   * @param element The {@link HTMLElement} to unregister.
   */
  unregisterElement(e) {
    var i;
    (i = this.observer) == null || i.unobserve(e);
    const s = this.getRegisteredElementIndex(e);
    s < 0 || this.registeredElements.splice(s, 1);
  }
  /**
   * Unregister multiple {@link HTMLElement}s from observation.
   *
   * @param elements The {@link HTMLElement}s to unregister.
   */
  unregisterElements(e) {
    for (const s of e)
      this.unregisterElement(s);
  }
  /**
   * Helper function to retrieve the index of a registered {@link HTMLElement} from the `registeredElements` array.
   *
   * @param el The {@link HTMLElement} to find.
   * @returns The index of the element if found, otherwise `-1`.
   *
   * @private
   */
  getRegisteredElementIndex(e) {
    return this.registeredElements.findIndex((s) => s.el === e);
  }
  /**
   * Helper function to retrieve a registered {@link HTMLElement} from the `registeredElements` array.
   *
   * @param el The {@link HTMLElement} to find.
   *
   * @returns The found element, otherwise `undefined`.
   *
   * @private
   */
  getRegisteredElement(e) {
    const s = this.getRegisteredElementIndex(e);
    if (!(s < 0))
      return this.registeredElements[s];
  }
  /**
   * The {@link IntersectionObserver} callback function to handle updates to the registered {@link TRegisteredElement}s
   * {@link HTMLElement}s. Registers or unregisters items based on the given settings and changes their state.
   *
   * @param entries Intersection element entries.
   *
   * @private
   */
  observerHandler(e) {
    for (const s of e) {
      const i = s.target, n = this.getRegisteredElement(i);
      if (n) {
        if (s.isIntersecting) {
          this.visibleElements.findIndex((l) => l === n.el) === -1 && this.visibleElements.push(n.el);
          continue;
        }
        this.removeFromVisibleStore(n.el), (n.state.isFilled || n.state.isVisible) && requestAnimationFrame(() => {
          this.processViewportIntersection(n, {
            isVisible: !1,
            isFilled: !1,
            passedValidityPeriod: !1
          });
        });
      }
    }
    this.visibleElements.length > 0 && this.frameTicker.start();
  }
  /**
   * Callback for the {@link FrameTicker} to frequently check the state of all elements which are currently marked as
   * _in the viewport_.
   *
   * @private
   */
  checkVisibilityOfElements() {
    if (this.visibleElements.length === 0)
      return;
    const e = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0), s = window.scrollY;
    for (let i = 0; i < this.visibleElements.length; i++) {
      const n = this.visibleElements[i], l = this.getRegisteredElement(n);
      if (!l || !this.settings.triggerUpdates.enabled && l.state.passedValidityPeriod)
        continue;
      const { isVisible: a, isFilled: d } = $.percentWithinViewport(n, s, e), c = {
        isVisible: a >= this.settings.thresholds.visible,
        isFilled: d >= this.settings.thresholds.filled,
        passedValidityPeriod: l.state.passedValidityPeriod
      };
      this.processViewportIntersection(l, c);
    }
  }
  /**
   * Get to know how much of the {@link HTMLElement} is visible the viewport.
   *
   * @param el The element in the viewport.
   * @param scrollY The scrollY of the current window.
   * @param viewportHeight The height of the viewport.
   *
   * @returns The % visible of the HTMLElement in the viewport.
   *
   * @private
   */
  static percentWithinViewport(e, s, i) {
    const n = { top: s, bottom: s + i }, l = e.getBoundingClientRect(), a = {
      top: l.y + s,
      bottom: l.y + l.height + s
    }, d = l.height;
    let c = d;
    a.top < n.top && (c = d - (s - a.top)), a.bottom > n.bottom && (c = c - (a.bottom - n.bottom));
    let h = c / d, g = c / i;
    return (n.top > a.bottom || n.bottom < a.top) && (h = 0, g = 0), n.top < a.top && n.bottom > a.bottom && (h = 1), a.top < n.top && a.bottom > n.bottom && (g = 1), {
      isVisible: h,
      isFilled: g
    };
  }
  /**
   * Processes a {@link TRegisteredElement} items intersection. If the element matches the
   * {@link TViewportTrackerSettings.thresholds `thresholds`}, the {@link IGlobalDataLayer.push} method is called.
   *
   * Also dispatches the update event of the {@link TViewportTrackerSettings.triggerUpdates `triggerUpdates`} feature.
   *
   * @param registeredElement The registered element to process.
   * @param isVisible Indicates, if the element is {@link TViewportTrackerSettings.thresholds.visible visible}.
   * @param isFilled Indicates, if the element is {@link TViewportTrackerSettings.thresholds.filled filled}.
   *
   * @private
   */
  processViewportIntersection(e, { isVisible: s, isFilled: i }) {
    const n = e.state || {
      isVisible: !1,
      isFilled: !1
    }, l = Date.now(), a = {
      isVisible: s,
      isFilled: i,
      timeVisible: n.isVisible !== s ? l : n.timeVisible,
      timeFilled: n.isFilled !== i ? l : n.timeFilled,
      passedValidityPeriod: n.passedValidityPeriod
    }, d = (c) => (l - c) / 1e3;
    if (n.isVisible !== a.isVisible || n.isFilled !== a.isFilled)
      a.passedValidityPeriod = !1, e.state = a, this.dispatchEvent(e);
    else if (!a.passedValidityPeriod && (a.isVisible || a.isFilled)) {
      const c = d(a.timeVisible), h = d(a.timeFilled);
      (s && c >= this.settings.thresholds.minValidityPeriod || i && h >= this.settings.thresholds.minValidityPeriod) && (a.passedValidityPeriod = !0, e.state = a, this.pushEvent(e), this.dispatchEvent(e));
    }
  }
  /**
   * Helper function to remove an {@link HTMLElement} from the state of being in the viewport. This will stop the
   * {@link FrameTicker} checks from being processed for this {@link TRegisteredElement}.
   *
   * @param element The HTMLElement to remove.
   *
   * @private
   */
  removeFromVisibleStore(e) {
    let s = -1;
    for (; (s = this.visibleElements.findIndex((i) => i === e)) >= 0; )
      this.visibleElements.splice(s, 1);
    this.visibleElements.length === 0 && this.frameTicker.stop();
  }
  /**
   * Will call the {@link IGlobalDataLayer.push} with the given {@link TViewportTrackerSettings.eventName `eventName`},
   * whenever a {@link TRegisteredElement} matches the given {@link TViewportTrackerSettings.thresholds `thresholds`}.
   *
   * @param item The registered {@link HTMLElement} with its {@link TRegisteredElement.properties `properties` payload}.
   *
   * @private
   */
  pushEvent(e) {
    if (!this.dataLayerInstance) {
      this._logger.warn("This extension is not registered to a GlobalDataLayer instance.");
      return;
    }
    const { properties: s } = e, i = typeof s == "function" ? s() : s || {};
    this.dataLayerInstance.push(this.settings.eventName, i);
  }
  /**
   * Dispatches a {@link ViewportTrackerStatusChangeEvent}.
   *
   * @param registeredElement The registered {@link HTMLElement} to use as target.
   *
   * @private
   */
  dispatchEvent(e) {
    this.settings.triggerUpdates && this.settings.triggerUpdates.enabled && e.el.dispatchEvent(
      new se(this.settings.triggerUpdates.eventName, e)
    );
  }
}
const I = (r) => r.length > 0, O = "PageNameExtender_unknown_pageName", S = {
  initialPageName: O,
  separator: "/"
};
class ae extends L {
  /**
   * Constructor of PageNameExtender
   *
   * @param options Settings object for this extension.
   */
  constructor(e) {
    super("PageNameExtenderExtension", e == null ? void 0 : e.logger);
    o(this, "settings");
    /**
     * Internal page name store. To handle the different levels.
     */
    o(this, "pageName", []);
    /**
     * Internal basic page name length. This is defined in the {@link set} method and used to make sure there is
     * an option to keep ({@link reduce}) or replace ({@link set}) the basic page name.
     */
    o(this, "basePageNameLength", 0);
    this.settings = e ? u(S, e) : S, this.set(this.settings.initialPageName);
  }
  /**
   * Update the complete stored {@link pageName} with a string or an array of strings.
   *
   * @param pageName If a simple string is given, it will be separated by the given {@link settings} separator.
   * @param keepExtensions Keep the parts which were added by {@link extend} method.
   *
   * @returns The new {@link pageName} joined with the {@link settings} separator.
   */
  set(e, s = !1) {
    const i = this.basePageNameLength;
    return typeof e == "string" && (e = e.split(this.settings.separator).filter(I)), e.length === 0 ? (this._logger.warn("`pageName` must not be empty"), "") : (e[0] === O && this._logger.info(
      "No `initialPageName` was provided. Make sure the `pageName` is provided later via the `set` method."
    ), this.basePageNameLength = e.length, s && e.push(...this.pageName.slice(i - 1)), this.pageName = e, this.get());
  }
  /**
   * Get the current {@link pageName}.
   *
   * @param basePageNameOnly If you want to ignore the parts which were added by {@link extend}.
   *
   * @returns The current {@link pageName} joined with the {@link settings} separator.
   */
  get(e = !1) {
    return (e ? this.pageName.slice(0, this.basePageNameLength) : this.pageName).join(
      this.settings.separator
    );
  }
  /**
   * Add (multiple) sub levels to the {@link pageName}.
   *
   * @param levels If a simple string is given it will be split by the given {@link settings} separator.
   *
   * @returns The new {@link pageName} joined with the given {@link settings} separator.
   */
  extend(e) {
    return Array.isArray(e) && (e = e.join(this.settings.separator)), e = e.split(this.settings.separator).filter(I), e.length === 0 ? this._logger.warn("`levels` must not be empty") : this.pageName.push(...e), this.get();
  }
  /**
   * Remove (multiple) sub levels from the {@link pageName}.
   *
   * @param [levelCount='last'] Number of levels that should be removed. You can also use a
   *   {@link TPageNameExtenderReduceType} to define the "last" or "all" (except the root).
   * @param keepBasePageName If the basic page name given by {@link set} should also be reducible. This
   *   cannot be restored.
   *
   * @returns The new {@link pageName} joined with the given {@link settings} separator.
   */
  reduce(e = "last", s = !0) {
    let i;
    return e === "all" ? i = this.pageName.length - (s ? this.basePageNameLength : 1) : e === "last" ? i = this.pageName.length > (s ? this.basePageNameLength : 1) ? 1 : 0 : (i = e, (this.pageName.length <= e || s && this.pageName.length - this.basePageNameLength < e) && (this._logger.info(
      `${this.pageName.length - (s ? this.basePageNameLength : 1)} - ${e} must not delete first level or more`
    ), i = this.pageName.length - (s ? this.basePageNameLength : 1))), this.pageName.splice(i * -1, i), this.basePageNameLength > this.pageName.length && (this.basePageNameLength = this.pageName.length), this.get();
  }
  /**
   * Get a temporary pre-fixed version of the current {@link pageName}.
   *
   * @param [prefix=''] The value that should be prepended temporarily.
   *
   * @returns The current {@link pageName} joined with the given {@link settings} separator pre-fixed with the given
   *   string value.
   */
  getWithPrefix(e = "") {
    return e + this.get();
  }
  /**
   * Get a temporary post-fixed version of the current {@link pageName}.
   *
   * @param [postfix=''] The value that should be appended temporarily.
   *
   * @returns The current {@link pageName} joined with the given {@link Settings} separator post-fixed with the given
   *   string value.
   */
  getWithPostfix(e = "") {
    return this.get() + e;
  }
}
class ie {
  /**
   * Create an instance of the GlobalDataLayer library. This constructor has to be overwritten to initialize the needed
   * factories ({@link _eventNamePayloadFactory} and {@link _webPayloadFactory}).
   *
   * @param options All options are merged with the {@link DEFAULT_SETTINGS} of type {@link TSettings}.
   * @param [dataStore] The array where all the pushes are added to. The default tries to get or generate the
   *   `window.pagData` array. If this is not possible, it creates an empty array, that is exposed via
   *   {@link DataLayerStore}.
   * @param [className] The class name of the library is here, because code can be uglified and/or minified later.
   *
   * @protected
   */
  constructor(t, e, s = "GlobalDataLayer") {
    /**
     * The class name of the library. This is needed, because code can be uglified and/or minified later.
     * @protected
     */
    o(this, "_className");
    /**
     * The merged settings. Also see the options of the {@link constructor} and the {@link DEFAULT_SETTINGS}.
     * @protected
     */
    o(this, "_settings");
    /**
     * An internal store where all default properties are added to.
     * @protected
     */
    o(this, "_defaultProperties");
    /**
     * An internal logger, which has to be used for all console logs.
     * @protected
     */
    o(this, "_logger");
    /**
     * A flag that indicates if the _Web Properties_ feature was already handled.
     *
     * @see {@link getWebProperties}
     *
     * @protected
     */
    o(this, "_webPropertiesHandled", !1);
    /**
     * the _DataLayer_ store array, that is used to push all the data.
     *
     * This can be transferred to the library with the second parameter `dataStore` of the {@link constructor}.
     *
     * @protected
     */
    o(this, "_dataLayerStore");
    /**
     * An internal store where all registered extensions are added to.
     * @protected
     */
    o(this, "_extensions", /* @__PURE__ */ new Map());
    const i = u(
      w,
      t || {}
    );
    this._className = s, this._logger = new b(this._className, i.logging), this._settings = i, e ? this._dataLayerStore = e : typeof window < "u" ? (this._dataLayerStore = window.pagData = window.pagData || [], this._logger.info("`dataLayerStore` was set to default `window.pagData`")) : (this._dataLayerStore = [], this._logger.info("`dataLayerStore` was set to default `[]`")), this._defaultProperties = [];
  }
  /**
   * An internal function to set everything up after initialization is done. This has to be called at the end of the
   * overwritten constructors.
   * @protected
   */
  setup() {
    this._handleDefaultWebProperties();
  }
  /**
   * The current settings object.
   * @readonly
   */
  get Settings() {
    return this._settings;
  }
  /**
   * Get the _DataLayer_ store, that is used to push all the data.
   * @readonly
   */
  get DataLayerStore() {
    return this._dataLayerStore;
  }
  /**
   * Get a registered {@link DataLayerExtension} class instance based of the input type.
   *
   * @param TConstructor The class to search for.
   *
   * @returns The registered instance of the extension class, `undefined` if not found.
   */
  getRegisteredExtension(t) {
    const e = new t();
    return this.getRegisteredExtensionByClassName(e.className);
  }
  /**
   * Get a registered {@link DataLayerExtension} class instance based of a classname.
   *
   * @param className The name of class instance to compare.
   *
   * @returns The registered instance of the extension class, undefined if not found.
   */
  getRegisteredExtensionByClassName(t) {
    return this._extensions.has(t) ? this._extensions.get(t) : void 0;
  }
  /**
   * Get all registered {@link DataLayerExtension}.
   *
   * @returns All registered DataLayerExtensions as array.
   */
  getRegisteredExtensions() {
    const t = [];
    for (const e of this._extensions.values())
      t.push(e);
    return t;
  }
  /**
   * Register a new {@link DataLayerExtension} class for this instance.
   *
   * @param extension The extension class instance to register.
   * @param override If there is an existing instance already registered, we override it, otherwise we do nothing.
   */
  registerExtension(t, e = !1) {
    if (!e && this._extensions.has(t.className)) {
      this._logger.warn(`Tried to register extension class <${t.className}> which already exists.`);
      return;
    }
    t.dataLayerInstance = this, this._extensions.set(t.className, t), e ? this._logger.info(`Overriden registration for extension class <${t.className}>.`) : this._logger.info(`Registered extension class <${t.className}>.`);
  }
  /**
   * Remove a registered {@link DataLayerExtension} instance.
   *
   * @param TConstructor The class to search for.
   */
  removeExtension(t) {
    const e = new t();
    if (this._extensions.has(e.className)) {
      this._extensions.delete(e.className);
      return;
    }
    this._logger.warn(`Tried to remove not existing extension class <${e.className}>.`);
  }
  /**
   * Remove a registered {@link DataLayerExtension} instance by class name.
   *
   * @param className the name of the class
   */
  removeExtensionByClassName(t) {
    if (this._extensions.has(t)) {
      this._extensions.delete(t);
      return;
    }
    this._logger.warn(`Tried to remove not existing extension class <${t}>.`);
  }
  /**
   * Push a GlobalDataLayer Event with payload to the given data layer store. The method can fail and return `false`
   *   because ...
   *
   *   - the given `eventName` was invalid
   *   - the validation failed
   *
   * A settings object can be added as the third parameter to every call. This will then temporary override the provided
   * settings for the time of the push action.
   *
   * @param eventName The name of the event that should be pushed.
   * @param [payload] The _DataLayer_ properties to be merged and added to the data layer.
   * @param [options] Temporary override the settings.
   *
   * @returns A boolean to indicate, if the push was successful.
   */
  push(t, e = [{}], s) {
    var d, c;
    if (t.length === 0)
      return !1;
    const i = s && !m(s) ? u(this._settings, s) : this._settings;
    Array.isArray(e) || (e = [e]), e.forEach(V);
    const n = this._eventNamePayloadFactory.create({ event: t }), l = V(this.getDefaultProperties(t));
    i.clean.enabled && i.clean.executionPlace === y.BEFORE_MERGE && [l || {}, ...e].forEach(
      (h) => P(h, i.clean.values)
    );
    const a = u(
      n,
      l || {},
      ...e
    );
    if (i.clean.enabled && i.clean.executionPlace === y.AFTER_MERGE && P(a, i.clean.values), (d = i == null ? void 0 : i.validation) != null && d.enabled && ((c = i == null ? void 0 : i.validation) != null && c.eventMatrix)) {
      const h = te(t, a, i.validation), g = h.issues.sort((f, p) => f.level !== p.level && p.level === "warn" ? -1 : 0).map((f) => `- [${f.level}]: ${f.message}`).join(`
`);
      switch (h.level) {
        case "error":
          return this._logger.error(
            `Validation failed for event '${t}' with errors/warnings: 
${g}`,
            i.logging
          ), !1;
        case "warn":
          this._logger.warn(
            `Validation success for event '${t}' with warnings: 
${g}`,
            i.logging
          );
          break;
        default:
          this._logger.info(`Validation success for event '${t}'.`, i.logging);
          break;
      }
    }
    return this._dataLayerStore.push(a), !0;
  }
  /**
   * Return the default properties for the given identifier.
   *
   * @param identifier The identifier to get the default properties for.
   *
   * @returns The found default properties for the identifier, otherwise `undefined`.
   */
  getDefaultProperties(t) {
    const e = {
      byName: [],
      byArray: [],
      byRegex: []
    };
    this._defaultProperties.forEach((i) => {
      if (i.identifier === t)
        return e.byName.push(i.data);
      if (Array.isArray(i.identifier) && i.identifier.includes(t))
        return e.byArray.push(i.data);
      if (i.identifier instanceof RegExp && i.identifier.test(t))
        return e.byRegex.push(i.data);
    });
    const s = [...e.byRegex, ...e.byArray, ...e.byName];
    if (s.length)
      return u(...s);
  }
  /**
   * Set default properties, which will later be merged with the payload of a {@link push}, when the provided identifier
   * matches the `eventName`.
   *
   * @param identifier The identifier to use the default properties for.
   * @param data The default properties which will be used with the provided identifier to merge those properties with the payload.
   */
  setDefaultProperties(t, e) {
    const s = this._defaultProperties.find((i) => i.identifier === t);
    if (s) {
      s.data = u(s.data, e);
      return;
    }
    this._defaultProperties.push({
      identifier: t,
      data: e
    });
  }
  /**
   * Checks if the web properties feature ({@link getWebProperties}) is already handled or does the setup with the
   * current settings.
   *
   * @private
   */
  _handleDefaultWebProperties() {
    if (this._webPropertiesHandled || !this._settings.webProperties.enabled)
      return;
    const t = Z(
      this._settings.webProperties,
      this._webPayloadFactory
    );
    this.setDefaultProperties(this._settings.webProperties.eventNamePattern, t), this._webPropertiesHandled = !0;
  }
}
class oe extends ie {
  /**
   * Create an instance of the GlobalDataLayer library.
   *
   * @param options All options are merged with the {@link DEFAULT_SETTINGS} of type {@link TSettings}.
   * @param [dataStore] The array where all the pushes are added to. The default tries to get or generate the
   *   `window.pagData` array. If this is not possible, it creates an empty array, that is exposed via
   *   {@link DataLayerStore}.
   * @param [className] The class name of the library is here, because code can be uglified and/or minified later.
   *
   * @protected
   */
  constructor(e, s, i = "GlobalDataLayer") {
    super(e, s, i);
    o(this, "_eventNamePayloadFactory");
    o(this, "_webPayloadFactory");
    this._eventNamePayloadFactory = new U(), this._webPayloadFactory = new q(), this.setup();
  }
  setup() {
    super.setup();
  }
}
export {
  y as CleanExecutionPlace,
  w as DEFAULT_SETTINGS,
  L as DataLayerExtension,
  U as EventNameFactory,
  H as FrameTicker,
  oe as GlobalDataLayer,
  ie as GlobalDataLayerBaseClass,
  b as Logger,
  ae as PageNameExtenderExtension,
  $ as ViewportTrackerExtension,
  se as ViewportTrackerStatusChangeEvent,
  q as WebPropertiesFactory,
  P as clean,
  G as cleanByDataLayerPaths,
  _ as each,
  N as eachFirstLevel,
  V as executeEachFunction,
  B as get,
  C as getDataLayerPaths,
  Z as getWebProperties,
  m as isEmpty,
  ne as isEmptyDataLayer,
  u as merge,
  te as validate
};
